import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonProductDetailsComponentBase } from '../../CommonProductDetailsComponentBase';

@Component({
  selector: 'ideal-product-vendor-link',
  imports: [RouterModule],
  templateUrl: './product-vendor-link.component.html',
  styleUrl: './product-vendor-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductVendorLinkComponent extends CommonProductDetailsComponentBase {
  protected readonly vendor = computed(() => this.productDetails()?.vendor);
}
